module.exports = __webpack_public_path__ + "img/4.f033ee4d.jpg";;
if (typeof window !== 'undefined') {
(window.__IMAGE_SIZES__ || (window.__IMAGE_SIZES__ = {}))[module.exports] = {"width":1062,"height":1448,"variants":[{"file":"img/4-480w.9569bcade2de.webp","width":480},{"file":"img/4-960w.9cda741cbc0d.webp","width":960},{"file":"img/4-1062w.c16774360db1.webp","width":1062}]};
}